<template>
    <div class="admin-site-options-form container">
        <div class="row py-5">
            <div class="col-12">
                <h1 class="pstitle">
                    <a href="/admin/cms">Admin CMS</a>
                    <span> - </span>
                    <a href="/admin/cms/site-options">Site Options</a>
                </h1>
            </div>
            <div class="col-12">
                <i><strong>Note:</strong> Saved changes take effect on the next page load.</i>
            </div>
        </div>

        <div class="col-sm-12 text-end form-options">
            <a href="javascript:void(0)" class="pt-1 cursor" :onclick="handleRevertSiteOptions" aria-label="Revert Site Options">Revert</a>
        </div>

        <div class="row py-3">
            <div class="col-xs-12 col-md-2">
                <input type="number" min="1" max="100"
                       class="form-control"
                       id="boatsPerPage"
                       placeholder="8"
                       v-model.number="boatsPerPage" />
                <label for="boatsPerPage" class="form-label">Boats per Page</label>
            </div>
        </div>

        <div class="flex justify-content-end">
            <span class="me-3 pt-2">{{ saveMessage }}</span>
            <custom-button class="btn-main"
                    v-on:btnClicked="handleSaveSiteOptions">
                Save Site Options
            </custom-button>
        </div>

                <modal-card v-model="showConfirmSave"
                    title="Confirm Save"
                    size="sm">
            <p class="text-black">Are you sure you want to save these site options as they are currently configured?</p>
            <p class="text-black">This updates the site for every brand on the next page load.</p>

            <template #footer="{ close }">
                <custom-button class="btn-main" v-on:btnClicked="close">
                    Cancel
                </custom-button>
                <custom-button class="btn-main" v-on:btnClicked="handleConfirm">
                    Save
                </custom-button>
            </template>
        </modal-card>
    </div>
</template>

<script>
import CustomButton from "../../components/atoms/CustomButton.vue";
import ModalCard from "../../components/atoms/ModalCard.vue";
import siteConfig from "../../constants/runtime-config";

export default {
    name: "SiteOptionsCmsPage",
    components: {
        CustomButton,
        ModalCard,
    },
    data() {
        const current = siteConfig["labels-config"].boatsPerPage;
        return {
            boatsPerPage: current,
            savedBoatsPerPage: current,
            saveMessage: "",
            showConfirmSave: false,
        };
    },
    methods: {
        handleSaveSiteOptions() {
            // min/max on the input don't stop typed values, so check before confirming
            const value = this.boatsPerPage;
            if (!Number.isInteger(value) || value < 1 || value > 100) {
                this.saveMessage = "Boats per page must be a whole number from 1 to 100.";
                return;
            }
            this.saveMessage = "";
            this.showConfirmSave = true;
        },

        handleConfirm() {
            this.showConfirmSave = false;
            this.saveSubmit();
        },

        saveSubmit() {
            this.saveMessage = "Saving...";
            this.axios.post("/admin/site-config", { "labels-config": { boatsPerPage: this.boatsPerPage } })
                .then(() => {
                    this.savedBoatsPerPage = this.boatsPerPage;
                    this.saveMessage = "Saved.";
                })
                .catch((err) => {
                    this.saveMessage = "Save failed (" + (err.response?.status ?? "network error") + ").";
                    console.log(err);
                });
        },
        handleRevertSiteOptions() {
            this.boatsPerPage = this.savedBoatsPerPage;
        },
    },
};
</script>

<style lang="scss">
.admin-site-options-form {
    .form-control {
        appearance: auto;
    }

    .row {
        row-gap: 1rem;
    }

    // Keep the label floated above the field even while the placeholder is showing
    .row .form-control + .form-label {
        top: -45px;
    }

    .form-options {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
    }
}
</style>